export type ProfileSectionTab = 'facts' | 'life-events' | 'relationships' | 'memories';

/** i18n keys under `screens` for intros below profile section tabs. */
export const PROFILE_SECTION_LEDE_KEYS: Record<ProfileSectionTab, string> = {
  facts: 'personProfile.sectionLedes.facts',
  'life-events': 'personProfile.sectionLedes.lifeEvents',
  relationships: 'personProfile.sectionLedes.relationships',
  memories: 'personProfile.sectionLedes.memories'
};

export function parseProfileSectionParam(value: string | null): ProfileSectionTab | null {
  if (value === 'facts' || value === 'life-events' || value === 'relationships' || value === 'memories') {
    return value;
  }
  return null;
}
